export const SET_WS_STATE = 'SET_WS_STATE';
export const SET_WS_AUTH = 'SET_WS_AUTH';
export const READ_NOTIFICATION = 'READ_NOTIFICATION';
